import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-and-shipping-boxes.jpg'),
    alt: 'storage and shipping boxes page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage and shipping boxes page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Find <span>Storage</span><span>and Shipping Boxes</span>',
  description:
    "Whether you're moving, storing, or shipping, our high-quality storage and shipping boxes offer the perfect solution to keep your belongings safe and secure during transport and storage.",
  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/hero-image.jpg',
    alt: 'Find Storage and Shipping Boxes'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Storage & Shipping Boxes' }
}

export const ourProcessSectionContent = {
  title: 'How Our Storage and Shipping Boxes Help You',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/how-our-storage-and-shipping-boxes-help-you.png',
    alt: 'How Our Storage and Shipping Boxes Help You'
  },

  articles: [
    {
      id: 1,
      title: 'Durable and Reliable',
      description:
        'Our boxes are built to last, offering superior protection for your items during storage or shipping, whether local or international.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/durable-and-reliable.png',
        alt: 'Durable and Reliable'
      }
    },
    {
      id: 2,
      title: 'Variety of Sizes',
      description:
        'Choose from a range of box sizes to fit your unique storage and shipping needs – from small items to large furniture.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/variety-of-sizes.png',
        alt: 'Variety of Sizes'
      }
    },
    {
      id: 3,
      title: 'Easy to Use',
      description: 'Our boxes are easy to pack and seal, ensuring a hassle-free storage or shipping experience.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/easy-to-use.png',
        alt: 'Easy to Use'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Shipping and Storage Box Solutions',
  description:
    'Our storage and shipping boxes are designed to offer maximum security, ease of use, and reliable protection, making them ideal for both personal and business use.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/shipping-and-storage-box-solutions.jpg',
    alt: 'Shipping and Storage Box Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Our Storage and Shipping Boxes',

  cards: [
    {
      id: 1,
      title: 'Superior Protection',
      description:
        'Our boxes are designed with durability in mind, ensuring your items remain safe during transit and storage.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/superior-protection.png',
        alt: 'Superior Protection'
      }
    },
    {
      id: 2,
      title: 'Wide Selection of Sizes',
      description:
        'Choose the right box size for your belongings, with options ranging from small parcels to large furniture.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/wide-selection-of-sizes.png',
        alt: 'Wide Selection of Sizes'
      }
    },
    {
      id: 3,
      title: 'Affordable Pricing',
      description:
        'We offer competitive prices on all our boxes, making it easy to find the perfect solution within your budget.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/affordable-pricing.png',
        alt: 'Affordable Pricing'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Our Storage and Shipping Boxes?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Homeowners',
          description:
            'Store seasonal items, extra furniture, or delicate belongings with peace of mind in our sturdy boxes.'
        },
        {
          id: 2,
          title: 'Business Owners',
          description: 'Keep your inventory, equipment, and documents safe and organized for shipping or storage.'
        },
        {
          id: 3,
          title: 'Students',
          description:
            'Store your dorm room essentials or ship belongings back home during breaks using our reliable boxes.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/who-should-use-our-storage-and-shipping-boxes.jpg',
        alt: 'Who Should Use Our Storage and Shipping Boxes?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Flexible Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Moving Box Solution',
      description:
        'Pack your belongings securely for your move with boxes that are specifically designed to handle everything from fragile items to heavy furniture.',
      image: {
        src: '/images/v2/pages/common/moving-box-solution.png',
        alt: 'Moving Box Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Storage Box Solution',
      description:
        'Store your personal items, seasonal decorations, or business inventory in our high-quality boxes, ensuring they stay safe for as long as you need.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Storage Box Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Shipping Box Solution',
      description:
        'Ship items locally or internationally with our specially designed shipping boxes that offer maximum protection during transit.',
      image: {
        src: '/images/v2/pages/common/shipping-box-solution.png',
        alt: 'Shipping Box Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Specialty Box Solution',
      description:
        'Need a box for a unique item? We offer specialty boxes for fragile, oversized, or irregularly shaped items.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Specialty Box Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Your Storage and Shipping Boxes?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/why-choose-shipandstorage-for-your-storage-and-shipping-boxes.jpg',
    alt: 'Why Choose ShipAndStorage for Your Storage and Shipping Boxes?'
  },

  articles: [
    {
      id: 1,
      title: 'Durable and Reliable',
      description:
        'Our boxes are built to withstand the rigors of shipping and storage, ensuring that your items are fully protected.'
    },
    {
      id: 2,
      title: 'Easy Packing and Handling',
      description:
        'Our boxes are easy to pack, tape, and seal, making your storage or shipping experience simple and efficient.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description: 'We offer competitive pricing for our boxes, with no hidden fees, so you can budget effectively.'
    },
    {
      id: 4,
      title: 'Fast Shipping',
      description:
        'Once your order is placed, we ensure prompt delivery of your boxes, so you’re ready to pack and ship in no time.'
    },
    {
      id: 5,
      title: 'Variety of Sizes',
      description:
        'Whether you’re shipping small electronics or large furniture, we have the right size box for every need.'
    },
    {
      id: 6,
      title: 'Customer-Centered Service',
      description:
        'Our team is committed to providing you with high-quality products and reliable support throughout your storage and shipping process.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Find Storage and Shipping Boxes for All Needs',
  description:
    'Find durable storage and shipping boxes for your needs. Affordable solutions for securely shipping and storing personal or business belongings.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-and-shipping-boxes/find-storage-and-shipping-boxes-for-all-needs.png',
    alt: 'Find Storage and Shipping Boxes for All Needs'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Order Boxes Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description:
    'ShipAndStorage partners with top logistics providers to ensure that your boxes are handled securely during transport and storage.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx offers reliable shipping services, ensuring your boxes are delivered on time and intact, wherever they are headed.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides international shipping solutions, ensuring your boxes arrive safely and on time, no matter the destination.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS ensures your boxes are securely stored and shipped, providing a reliable solution for both local and global shipments.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
